module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/reviewer-1-27cc9790963e151ed87a4618b9c698a7.webp";